import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getCardsConfig() {
    return {
        palette: {
            [PALETTE_IDS.CARDS_AND_PROMOTIONS]: {
                CARD_WATERMARK_ICON_COLOR: COLOR.BRAND.BACKGROUND6,
            },
            [PALETTE_IDS.PRICE_BOOST_BANNER]: {
                PRICE_BOOST_BANNER_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                PRICE_BOOST_BANNER_BOOST_ITEM: {
                    PBI_PREVIOUS_PRICE_HEADER_TEXT: COLOR.BRAND.FOREGROUND7,
                },
                PRICE_BOOST_BANNER_BOOST_LABEL: {
                    PRICE_BOOST_LABEL_ICON_COLOR: COLOR.BRAND.ACCENT1,
                    PRICE_BOOST_LABEL_TEXT: {
                        fontSize: 12,
                    },
                },
            },
            [PALETTE_IDS.EVENT_CARDS]: {
                CARD_SPORT_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                CARD_FALLBACK_MESSAGE_TEXT: COLOR.BRAND.FOREGROUND1,

                CARD_EVENT_NAME_TEXT: COLOR.BRAND.FOREGROUND2,
                CARD_MARKET_NAME_TEXT: COLOR.BRAND.FOREGROUND2,
                CARD_RACE_INFO_TEXT: COLOR.BRAND.FOREGROUND2,

                CARD_TIMING_STATUS: {
                    EVENT_TIMING_UPCOMING_TEXT: COLOR.BRAND.FOREGROUND2,
                },

                CARD_PARTICIPANTS: {
                    PITCHER_TEXT: COLOR.BRAND.FOREGROUND3,
                    PARTICIPANTS_TEXT: {
                        lineHeight: '16px',
                    },
                },
            },
            [PALETTE_IDS.PRE_BUILT_CARDS]: {
                CARD_MATCH_ACCA_EVENT_NAME_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                CARD_PREBUILT_ACCA_SELECTION_BB_BET_MARKET_TEXT: COLOR.BRAND.FOREGROUND2,
                CARD_PREBUILT_ACCA_SELECTION_BB_BET_EVENT_TEXT: COLOR.BRAND.FOREGROUND2,
            },
        },
    };
}
